import { forwardRef, PropsWithChildren, Ref } from "react"
import classNames from "classnames"

type TextElement = "span" | "p"

export type TextSize = "tiny" | "small" | "medium" | "large"

interface TextProps
  extends PropsWithChildren<React.HTMLAttributes<HTMLParagraphElement | HTMLSpanElement>> {
  as?: TextElement
  size?: TextSize
  className?: string
}

const large = "base-text-large"
const medium = "base-text-medium"
const small = "base-text-small"
const tiny = "base-text-tiny"

const mapStyles: Record<TextSize, string> = {
  tiny: tiny,
  small: small,
  medium: medium,
  large: large,
}

export const Text = forwardRef<HTMLElement, TextProps>(
  ({ as: Component = "p", size = "medium", className, children, ...rest }, ref) => {
    return (
      <Component
        className={classNames(mapStyles[size], className)}
        ref={ref as Ref<HTMLParagraphElement>}
        {...rest}
      >
        {children}
      </Component>
    )
  },
)
